/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_TitleInputs */



/**
* | output |
* | --- |
* | "Work Order Import" |
*
* @param {Work_Order_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_title = /** @type {((inputs?: Work_Order_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de l’ordre de travail")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeitsauftragsimport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione ordine di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт рабочего заказа")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de órdenes de trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("工作订单导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作業指示書のインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य आदेश आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de ordens de serviço")
	return /** @type {LocalizedString} */ ("Work Order Import")
});